import { Activity, BarChart3, Car, Cpu, Factory, FileText, Landmark, Pill, Zap } from 'lucide-react';

const iconRules = [
  { keywords: ['power', 'energy', 'utility', 'utilities', 'renewable', 'renewables', 'solar', 'wind'], Icon: Zap, color: 'text-blue-600', background: 'bg-blue-50', border: 'border-blue-200' },
  { keywords: ['pharma', 'healthcare', 'health', 'life science', 'life sciences', 'medical'], Icon: Pill, color: 'text-emerald-600', background: 'bg-emerald-50', border: 'border-emerald-200' },
  { keywords: ['metal', 'metals', 'mining', 'industrial', 'industry', 'manufacturing', 'steel'], Icon: Factory, color: 'text-emerald-600', background: 'bg-emerald-50', border: 'border-emerald-200' },
  { keywords: ['bank', 'banking', 'finance', 'financial', 'equity', 'capital market', 'nbfc'], Icon: Landmark, color: 'text-amber-600', background: 'bg-amber-50', border: 'border-amber-200' },
  { keywords: ['technology', 'tech', 'software', 'ai', 'artificial intelligence', 'digital', 'it '], Icon: Cpu, color: 'text-indigo-600', background: 'bg-indigo-50', border: 'border-indigo-200' },
  { keywords: ['auto', 'automotive', 'mobility', 'vehicle', 'transport'], Icon: Car, color: 'text-orange-600', background: 'bg-orange-50', border: 'border-orange-200' },
];

const toText = (value) => String(value || '').trim().toLowerCase();

export const resolveReportIcon = (report = {}) => {
  const filterText = [report.primaryFilter, report.primary_filter, report.sector, report.topic]
    .filter(Boolean)
    .map(toText)
    .join(' ');
  const titleText = [report.title, report.name, report.category, report.reportType, report.report_type]
    .filter(Boolean)
    .map(toText)
    .join(' ');

  const matchingRule = iconRules.find((rule) => rule.keywords.some((keyword) => filterText.includes(keyword)))
    || iconRules.find((rule) => rule.keywords.some((keyword) => titleText.includes(keyword)));

  return matchingRule || { Icon: FileText, color: 'text-slate-600', background: 'bg-slate-50', border: 'border-slate-200' };
};

export const ReportIcon = ({ report, className = '' }) => {
  const { Icon, color, background, border } = resolveReportIcon(report);
  return (
    <span className={`inline-flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg border ${background} ${border} ${color} ${className}`} aria-hidden="true">
      <Icon className="h-5 w-5" />
    </span>
  );
};
